module.exports = __webpack_public_path__ + "media/assets/svgs/download-c06854580b8ee7f4ccf9af9cb2529f34.svg";